export const dropdownPreset = {
  root: ({ props, state }: any) => ({
    class: [
      { 'hover:border-primary-500 dark:hover:!border-primary-400': !props.invalid },
      { '!ring-blue-200/50 dark:!ring-blue-600/50': state.focused },
    ],
  }),
  item: {
    class: ['text-[15px] '],
  },
  filterinput: {
    class: ['dark:hover:!border-blue-300'],
  },
  input: '!py-[11px]',
};
